fx.ns("shared.stage.components", class CalendarGridEditable extends shared.stage.components.BaseCalendarGrid {
    constructor(component, model, parent, manual, commands) {
        super(component, model, parent, commands);

        this.cellClass = shared.stage.CalendarCell;
        this.clickable = true;
    }

    /**
     * Component initialization.
     */
    create() {
        super.create();

        this.monthTitle.viewport({ top: 0, right: 12 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale });
        this.yearTitle.viewport({ top: (fx.get("app") == "screenshot") ? 14 * this.model.creation.extraScale : 13 * this.model.creation.extraScale, right: 12 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale });
        this.monthNumberTitle.viewport({ top: 0, height: 20 * this.model.creation.extraScale, left: 12 * this.model.creation.extraScale });
        this.titleContainer.viewport({ top: this.model.creation.isSinglePage ? 5 * this.model.creation.extraScale : 25 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale, width: "100%" });

        if (fx.browser.isMobile) {
            this.addEvent = new fx.components.Button({ label: fx.text("Ajoutez une date"), className: "add-date", type: "filled" });
            this.addChild(this.addEvent);
        }
    }

    onReady() {
        super.onReady();

        if (this.addEvent)
            this.on("click", this.addDate, this.addEvent);

        if (fx.get("app") == "screenshot")
            this.headerRow.top(this.headerRow.top() + 2);

        if (fx.browser.isMobile) {
            let scale = fx.graphics.getScale(this);
            let invertScale = 1/scale;
            this.addEvent.css({ "transform-origin" : "center top", "transform" : "scale(" + invertScale + ")"});
            this.addEvent.viewport({width : this.realWidth * 0.8 / invertScale, height : 30, bottom: 60 * invertScale, left : "center"});
            
        }
        
    }

    addDate() {
        this.data.event("edit-text-calendar");
    }
});